import "core-js";
import React, {useCallback, useState} from 'react';
import ReactDOM from 'react-dom/client';
import './index.scss';
import App from './App';
import {getSimpleReducer, StateContext} from './helpers/state-context.js';
import * as serviceWorker from './serviceWorker';
import {SizeContext} from "./helpers/size-context.js";
import {UrlStateContext} from "./helpers/url-state-context.js";
import {AnalyticsGoogle} from './helpers/analytics/google.js';
import {Analytics} from './helpers/analytics/index.js';


function SizedApp(){
    const [element, setElement] = useState(null);
    const measuredRef = useCallback(node => {
        if (node !== null) {
            setElement(node);
        }
    }, []);

    const getSize = function(width){
        let size = '';
        if (width > 1600) {
            size = 'xxl';
        } else if (width > 1200) {
            size = 'xl';
        } else if (width > 992) {
            size = 'lg';
        } else if (width > 768) {
            size = 'md';
        } else if (width > 576) {
            size = 'sm';
        } else {
            size = 'xs';
        }
        return size;
    }

    return <SizeContext stateName="renderSize" element={element} getSize={getSize}>
        <div ref={measuredRef}>
            <App/>
        </div>
    </SizeContext>;
}

const appReducer = (state, action) => {
    if (action.type === 'setDefaultCategories') {
        return {...state, categories: [1, 2, 3]};
    }else if (action.type === 'categories') {
        return {...state, categories: action.value};
    }else if (action.type === 'selectedCategory') {
        return {...state, selectedCategory: action.value};
    }else if (action.type === 'countryHover') {
        return {...state, countryHover: action.value};
    }else if (action.type === 'infoExpanded') {
        return {...state, infoExpanded: action.value};
    }
    return state;
}

const initialState = {

    infoExpanded: [true, false, false, false],
    categories: [1, 2, 3], 
    selectedCategory: null, 
    countryHover: null
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <UrlStateContext
            hash={['country', 'page']}
            initialState={{country: null, page: null,}}
            reducer={getSimpleReducer(['country', 'page'])}>

        <StateContext initialState={initialState}
                reducer={appReducer}>
            <SizedApp/>
        </StateContext>

    </UrlStateContext>
);

// initiate google analytics tracker(s)
const trackerIds = (window.analyticsTrackerId || '').split(',');
for(let trackerId of trackerIds){
    trackerId = trackerId.trim();
    if(trackerId.length > 4){
        const tracker = new AnalyticsGoogle({trackerId});
        Analytics.addTracker(tracker);
        // track initial page view
        // Analytics.trackPageView({title: 'Worldmap - home'});
    }
}

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
